import { render, staticRenderFns } from "./Lectures.vue?vue&type=template&id=0b2e15c9&"
import script from "./Lectures.vue?vue&type=script&lang=js&"
export * from "./Lectures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports